'use strict';

jQuery(function ($) {

  const header = $('#header');
  const root = document.documentElement;

  function calcHeaderHeight() {
    var stickyHeight = header.outerHeight();
    root.style.setProperty('--header-height', stickyHeight + 'px');
    $('body').addClass('has-header-height');
  }

  function calcHeights() {
    calcHeaderHeight();
  }

  $(document).ready(function () {

    calcHeights();

    window.addEventListener('resize', calcHeights);

    var topNav = $('#top-menu');

    $('#nav-toggle').click(function (e) {
      $('body').toggleClass('menu-open');
      $('#header .menu-wrapper').removeClass('submenu-open');
      $('.sub-menu-container', topNav).removeClass('active');
    });

    $('li.menu-item-has-children > a', topNav).click(function (e) {
      if ($(window).width() < 1350) {
        $('.sub-menu-container', topNav).removeClass('active');
        $(this).siblings('.sub-menu-container').addClass('active');
        $(this).parents('.menu-wrapper').addClass('submenu-open');
      }
    });

    $('.back-bar', topNav).click(function (e) {
      e.preventDefault();
      $(this).parents('.menu-wrapper').removeClass('submenu-open');
    });

    setTimeout(function () {
      if ($('.st-default-search-input').val() === '') {
        $('.st-ui-container.st-ui-container-overlay').addClass('empty');
      }
    }, 1000);

    $(document).on('keydown', '.st-default-search-input', function (e) {
      if ((e.key === 'Enter' || e.keyCode === 13 || e.which === 13 ) && $('.st-ui-container.st-ui-container-overlay').hasClass('empty')) {
        $('.st-search-results').hide();

        setTimeout(function () {
          $('.st-search-results').show(); 
          $('.st-ui-container.st-ui-container-overlay').removeClass('empty');
          $('.st-query-present').show();
          $('.st-ui-container-footer_bar').show();
        }, 500);
      }
    });

    
    $('.search-toggle').on('click', function (e) {
      e.preventDefault();
      $('.st-ui-embed').show();
      $('.st-ui-embed input').focus();
      $(document).on('keyup', hideSearchEscape);
      setTimeout(function () {
        $(document).on('click', hideSearchClick);
      }, 500);


      /* Add Clear search button */
      
      const $input = $('#st-overlay-search-input');
      const $closeBtn = $('.st-ui-close-button');
    
      if (!$('.st-ui-clear-button').length && $closeBtn.length) {
        // Create the Clear button
        const $clearBtn = $('<button>', {
          text: 'Clear',
          type: 'button',
          class: 'st-ui-clear-button button',
          css: {
            display: 'none'
          }
          
        });

        // Insert the button before the Close button
        $closeBtn.before($clearBtn);

        // Enable/Disable button on input change
        $input.on('input', function () {
          const hasValue = $(this).val().trim() !== '';
          if (hasValue) {
            $clearBtn.show();
            $('.st-search-results').show();
          } else {
            $clearBtn.hide();
          }

        });

        // Clear input and disable button
        $clearBtn.on('click', function () {
          $input.val('').focus();
          $(this).hide();

          $('#search-input').val('');
          $('.st-query-present').hide();
          $('.st-ui-container-footer_bar').hide();
          $('.st-ui-container.st-ui-container-overlay').addClass('empty');
          $('.st-search-results').hide();
          
          history.replaceState(null, null, window.location.pathname + window.location.search);
        });
      }
    });

    $('li.menu-item-has-children').each(function() {
      var $this = $(this);
      var liCount = $this.find('> ul > li').length;
      if (liCount >= 4) {
        $this.addClass('nested-two-col');
      }
    });

    function hideSearchEscape(e) {
      if (e.key === 'Escape') {
        $('.st-ui-embed').hide();
        $(document).off('keyup', hideSearchEscape);
      }
    }

    function hideSearchClick(e) {
      let $target = $(e.target);
      if (!$target.closest('.st-ui-container').length) {
        $('.st-ui-embed').hide();
        $(document).off('click', hideSearchClick);
      }
    }

    $(document).on('click', '.st-ui-close-button', function (e) {
      e.preventDefault();
      $('.st-ui-embed').hide();
      $(document).off('keyup', hideSearchEscape);
      $(document).off('click', hideSearchClick);
    });

    var flipCards = $('.ontinue-flip-cards');
    if (flipCards.length) {
        flipCards.on('click', '.card', function(e) {
            // Remove 'active' class from all sibling cards
            $(this).siblings().removeClass('active');
            // Toggle 'active' class on the clicked card
            $(this).toggleClass('active');
        });
    }

    var awardsRibbon = $('.awards-ribbon');

    if (awardsRibbon.length) {
      $('.award', awardsRibbon).clone().appendTo('.awards', awardsRibbon);
      $('.award', awardsRibbon).clone().appendTo('.awards', awardsRibbon);

      $('.awards', awardsRibbon).css('--award-width', $('.award', awardsRibbon).outerWidth() + 'px');
      $('.awards').css('--animation-duration-horizontal', Math.round($('.awards', awardsRibbon).outerWidth() / 150) + 's');
      $('.awards').css('--animation-duration-vertical', Math.round($('.awards', awardsRibbon).outerHeight() / 150) + 's');
      window.addEventListener('resize', function () {
        $('.awards', awardsRibbon).css('--award-width', $('.award', awardsRibbon).outerWidth() + 'px');
        $('.awards').css('--animation-duration-horizontal', Math.round($('.awards', awardsRibbon).outerWidth() / 150) + 's');
        $('.awards').css('--animation-duration-vertical', Math.round($('.awards', awardsRibbon).outerHeight() / 150) + 's');
      });

      $('.awards', awardsRibbon).addClass('animate');
    }

    var drawers = $('.ontinue-drawers');

    if (drawers.length) {
      $('.tab', drawers).click(function (e) {
        if ($(this).hasClass('active')) { return false; }
        $('.tab, .tab-content', drawers).removeClass('active');
        $(this).addClass('active');
        $('#' + $(this).data('tab')).addClass('active');
      });
    }

    var quoteCarousel = $('.ontinue-quote-carousel');
    if (quoteCarousel.length) {
      $(quoteCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: true,
          // slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          mobileFirst: true,
          dots: true,
          appendDots: $('.slick-dots-mobile', el),
          slide: '.slide',
          centerMode: true,
          centerPadding: '0px',
          prevArrow: $('.slick-prev', el),
          nextArrow: $('.slick-next', el),
          // appendArrows: $('.slick-nav', el),
          responsive: [{
            breakpoint: 768,
            settings: {
              appendDots: $('.slick-dots-desktop', el),
              // appendArrows: $('.carousel .slick-nav', el)
            }
          }]
        });
        $('.carousel', el).css('--carousel-height', $('.carousel', el).outerHeight() + 'px');
        window.addEventListener('resize', function () {
          $('.carousel', el).css('--carousel-height', $('.carousel', el).outerHeight() + 'px');
        });
      });

      $('.ontinue-quote-carousel .carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slick-slide.slick-highlight').removeClass('slick-highlight');
        $('.slick-slide[data-slide="' + nextSlide + '"]').addClass('slick-highlight');
      });
    }

    var logosCarousel = $('.ontinue-logos-carousel');
    if (logosCarousel.length) {
      $(logosCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          // rows: 3,
          // slidesPerRow: 1,
          // variableWidth: true,
          mobileFirst: true,
          dots: true,
          // slide: '.slide',
          prevArrow: '<span class="slick-prev">Previous</span>',
          nextArrow: '<span class="slick-next">Next</span>',
          // appendArrows: $('.slick-nav', el),
          responsive: [
            {
              breakpoint: 460,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                // rows: 2,
                // slidesPerRow: 2,
                dots: true
              }
            },
            {
              breakpoint: 655,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                // rows: 1,
                // slidesPerRow: 1,
                dots: true
              }
            },
            {
              breakpoint: 850,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                // rows: 1,
                // slidesPerRow: 1,
                dots: false
              }
            },
            {
              breakpoint: 1045,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                // rows: 1,
                // slidesPerRow: 1,
                dots: false
              }
            },
            {
              breakpoint: 1240,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
                // rows: 1,
                // slidesPerRow: 1,
                dots: false
              }
            }
          ]
        });
      });
    }

    var resourcesCarousel = $('.ontinue-resources-carousel');
    if (resourcesCarousel.length) {
      $(resourcesCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          dots: true,
          slide: '.slide',
          prevArrow: '<span class="slick-prev">Previous</span>',
          nextArrow: '<span class="slick-next">Next</span>',
          appendArrows: $('.slick-nav', el),
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false
              }
            }
          ]
        });
      });
    }

    var newsCarousel = $('.ontinue-news-carousel');
    if (newsCarousel.length) {
      $(newsCarousel).each(function (i, el) {
        $('.carousel', el).slick({
          infinite: false,
          rows: 3,
          slidesPerRow: 1,
          mobileFirst: true,
          dots: true,
          prevArrow: '<span class="slick-prev">Previous</span>',
          nextArrow: '<span class="slick-next">Next</span>',
          appendArrows: $('.slick-nav', el),
          responsive: [
            {
              breakpoint: 600,
              settings: {
                rows: 2,
                slidesPerRow: 2,
                dots: false
              }
            }
          ]
        });
      });
    }

    var overlay = $('.md-overlay');

    $('.md-trigger').each(function (i, el) {
      var modal = $('#' + el.getAttribute('data-modal')),
        close = $('.md-close', modal);

      function removeModal(hasPerspective) {
        $(modal).removeClass('md-show');

        if (hasPerspective) {
          $(document).removeClass('md-perspective');
        }
      }

      function removeModalHandler() {
        removeModal($(el).hasClass('md-setperspective'));
      }

      $(el).click(function (ev) {
        $(modal).addClass('md-show');
        $(overlay).off('click', removeModalHandler);
        $(overlay).on('click', removeModalHandler);

        if ($(el).hasClass('md-setperspective')) {
          setTimeout(function () {
            $(document).addClass('md-perspective');
          }, 25);
        }

        $(close).on('click', function (ev) {
          ev.stopPropagation();
          removeModalHandler();
        });

      });


    });

    // Resource center
    if ($('.ontinue-resource-center').length > 0) {
      let $module = $('.ontinue-resource-center');
      toggleApplyButton();

      $(window).on('click', function (e) {
        let $target = $(e.target);
        if (!$target.closest('.resource-filters-filter').length && !$target.is('a.eyebrow.filter-by') && $('.resource-filters-filter').is(':visible')) {
          $('.resource-filters-filter').slideUp();
          $('#resource-filter-overlay').remove();
          $module.find('.eyebrow.filter-by').removeClass('open');
        }
        if (!$target.closest('.resource-filters-filter-sort').length && !$target.is('a.eyebrow.sort-by') && $('.resource-filters-filter-sort').is(':visible')) {
          $('.resource-filters-filter-sort').slideUp();
        }
      });

      function updateResourceCenterGrid(args) {
        $module.find('.md-filter-overlay').show();
        $module.find('.open-positions-circle-loader').show();
        let top = $module.offset().top - $('#header').outerHeight();
        console.log("scrolling");
        $('html, body').animate({
          scrollTop: top
        }, 250, 'linear').promise().then(function () {
          $module.find('.resources-none-found').hide();
          let resource_types = $module.find('input[data-taxonomy=ontinue_resource_type]:checkbox:checked').map(function () {
            return $(this).val();
          }).get();
          let resource_topics = $module.find('input[data-taxonomy=ontinue_resource_topic]:checkbox:checked').map(function () {
            return $(this).val();
          }).get();

          let data = {
            paged: args.paged,
            base: $module.find('.resources').data('base'),
            action: 'resource_center_grid',
            resource_types: resource_types,
            resource_topics: resource_topics,
            order: $module.find('.resource-filters-filter-sort a.active').data('sort')
          };

          if (1 === args.paged && 0 === resource_types.length && 0 === resource_topics.length) {
            $module.find('.featured-post').show();
          } else {
            $module.find('.featured-post').hide();
          }

          $.ajax({
            url: window.ontinueJs.ajaxUrl,
            type: 'POST',
            dataType: 'json',
            data: data,
          }).done(function (resp) {
            $module.find('.md-filter-overlay').hide();
            $module.find('.open-positions-circle-loader').hide();

            $module.find('.resources').empty().html(resp.posts);
            if (resp.none_found) {
              $module.find('.resources-none-found').show();
              $module.find('.resources-pagination-inner').empty();
            } else {
              $module
                .find('.resources-pagination-inner')
                .empty()
                .html(resp.pagination);
            }
            args.url = decodeURI(args.url);
            window.history.pushState({}, '', args.url);

            // if (args.callback && typeof args.callback === 'function') {
            //   args.callback();
            // }
          });
        });
      }

      $module.on('click', '.page-numbers', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled'))
          return false;
        let url = $(this).attr('href');
        let paged = $(this).text();
        if ($(this).hasClass('next') || $(this).hasClass('prev')) {
          let current = parseInt($module.find('span.current').text());
          if ($(this).hasClass('next'))
            paged = current + 1;
          else
            paged = current - 1;
        }
        updateResourceCenterGrid({
          paged: paged,
          url: url
        });

      });

      $module.on('click', '.resource-filters a.eyebrow', function (e) {
        e.preventDefault();
        let $link = $(this);
        let target = $(this).data('open');
        $module.find(target).slideToggle(function () {
          $link.toggleClass('open');

          if ($link.hasClass('filter-by')) {
            if ($link.hasClass('open')) {
              let $overlay = $('<div>').attr('id', 'resource-filter-overlay');
              $('body').append($overlay);
              if (!$module.data('sized')) {
                $module.data('sized', true);
                $module.css({ 'min-height': $module.find('.resource-filters-filter').outerHeight() });
              }
            } else {
              $('#resource-filter-overlay').remove();
            }
          }
        });
      });

      $module.on('click', 'ul li', function () {
        let $checkbox = $(this).find('input');
        $checkbox.attr('checked', !$checkbox.prop('checked'));
        $(this).toggleClass('active');
        toggleApplyButton();
      });

      $module.on('click', '.apply-filters', function () {
        let url = buildUrl();
        updateResourceCenterGrid({
          paged: 1,
          url: url,
        });

        $('.resource-filters-filter').slideUp();
        $module.find('.eyebrow.filter-by').removeClass('open');
        $('#resource-filter-overlay').remove();
      });

      function toggleApplyButton() {
        if ($module.find('ul li input:checked').length > 0) {
          $module.find('.apply-filters').show();
        } else {
          $module.find('.apply-filters').hide();
        }
      }

      function buildUrl() {
        let url = $module.find('.resources').data('full-base');
        let resource_types = $module.find('input:checkbox:checked').map(function () {
          return { name: $(this).attr('name'), val: $(this).val() };
        }).get();
        if (resource_types.length > 0)
          url += '?' + resource_types.map(function (el) {
            return el.name + '=' + el.val;
          }).join('&');
        return url;
      }

      $module.on('click', '.resource-filters-filter a', function (e) {
        e.preventDefault();
        $(this).parent().slideUp();
        $module.find('.eyebrow.filter-by').removeClass('open');
        $('#resource-filter-overlay').remove();
      });

      $module.on('click', '.resource-filters-applied span a', function (e) {
        e.preventDefault();
        let $link = $(this);
        let slug = $(this).data('slug');
        $module.find('input[data-slug=' + slug + ']').attr('checked', false);
        $module.find('input[data-slug=' + slug + ']').closest('li').removeClass('active');
        $link.parent().parent().remove();
        if ($module.find('.resource-filters-filter input:checked').length === 0) {
          $module.find('.resource-filters-applied').hide();
        }
        updateResourceCenterGrid({
          paged: 1,
          url: buildUrl()
        });
      });

      $module.on('click', '.resource-filters-applied > a', function (e) {
        e.preventDefault();
        $module.find('input').attr('checked', false);
        $module.find('input').closest('li').removeClass('active');
        $module.find('.resource-filters-applied').empty();
        toggleApplyButton()
        updateResourceCenterGrid({
          paged: 1,
          url: buildUrl(),
        });
      });

      $module.on('click', '.resource-filters-filter-sort a', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active'))
          return;
        $module.find('.resource-filters-filter-sort a.active').removeClass('active');
        $(this).addClass('active');
        let sort = $(this).data('sort');
        updateResourceCenterGrid({
          paged: 1,
          url: buildUrl(),
          sort: sort
        });
        $module.find('.resource-filters-filter-sort').slideUp();
      });
    }

    $('.bio-modal').on('click', function (e) {
      $('body').toggleClass('has-modal');
    });
    
    $("#header.ontinue-header-wrapper .menu-wrapper nav .sub-menu.depth-1 li").not(":has(p)").css("margin-bottom", "0");

    $('.sub-menu.depth-1 a[href*="#"]').addClass('section-scroll');

    // Function to handle smooth scrolling
    function smoothScroll(target) { 
      if ($(target).length) {
        // Check if target exists 
        var headerHeight = $('header').outerHeight();
        var additionalOffset = 45; // Minimum space at the top
        var offset = $(target).offset().top - headerHeight - additionalOffset;
        $('html, body').animate({ 
            scrollTop: offset 
        }, 1000); 
      }
    }

    // Handle click events on <a> tags with the class 'section-scroll'
    $('a.section-scroll').on('click', function(event) {
      // Prevent the default action
      event.preventDefault();

      // Get the target ID
      var href = $(this).attr('href');
      var url = href.split('#')[0];
      var targetId = href.split('#')[1];
      var target = '#' + targetId;
      

      // Check if the URL part of the href is the same as the current page's URL
      if (url === '' || url === window.location.pathname || url === window.location.origin + window.location.pathname) {
          // Perform smooth scroll for the same page links
          smoothScroll(target);
          
      } else {
          // Store the target in local storage and navigate to the new page
          localStorage.setItem('scrollTarget', target);
          // Navigate to the new page for different page links
          window.location.href = href;
          //smoothScroll(target);
      }
    });

    // Check if there's a stored target and perform smooth scroll
    var storedTarget = localStorage.getItem('scrollTarget');
    if (storedTarget) {
        // Remove the item from local storage
        localStorage.removeItem('scrollTarget');
        // Perform smooth scroll to the stored target
        if ($(storedTarget).length) {
            var offset = $(storedTarget).offset().top - $('header').outerHeight() - 50; // Adjust for header height and additional 50px
            $('html, body').animate({
                scrollTop: offset
            }, 1000);
        }
    }
    
    const $firstElement = $('main .content').children().first(); 
    if ($firstElement.is('.section-success-stories')) { 
      $firstElement.css('padding-top', 'var(--header-height)'); 
    }

    const $successSlider = $('.jsSucessStoriesSlider');
    const slideCount = $successSlider.children().length;

    if($successSlider.length > 0){
      $successSlider.slick({
          dots: slideCount > 3, // Only show dots if there are more than 3 slides
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          prevArrow: "<img class='prev slick-prev' src='/wp-content/themes/ontinue/assets/images/on_prev_arrow.png' alt='previous-arrow'>",
          nextArrow: "<img class='next slick-next' src='/wp-content/themes/ontinue/assets/images/on_next_arrow.png' alt='next-arrow'>",
          responsive: [
              {
                  breakpoint: 1350,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: false,
                  }
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: false,
                  }
              }
          ]
      });
    }

    updateTabIndex();
    function updateTabIndex() {
      $('.sub-menu-container a').attr('tabindex', '-1');

      function onClassChange(selector, callback) {
        $(selector).each(function() {
          const targetNode = this;
      
          const observer = new MutationObserver(function(mutationsList) {
            for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                callback($(targetNode));
              }
            }
          });
      
          observer.observe(targetNode, { attributes: true, attributeFilter: ['class'] });
        });
      }
      
      onClassChange('li.menu-item-has-children', function($el) {
        if ($el.hasClass('open')) {
          $el.find('ul.sub-menu a').attr('tabindex', '0');
        } else {
          $el.find('ul.sub-menu a').attr('tabindex', '-1');
        }
      });
    }
  });

  $(function () {
    // accordion panel
    // (Optional) Active an item if it has the class "is-active"	
    $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();

    $(".accordion > .accordion-item").click(function () {
      // Cancel the siblings
      $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
      // Toggle the item
      $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
    });

    // resource detail share link (copy to clipboard)
    if ($('.share-link').length > 0) {
      $('body').on('click', '.share-link', function (e) {
        e.preventDefault();
        let $link = $(this);
        if ($link.data('url')) {
          var copyText = $link.data('url');

          // Copy the text inside the text field
          navigator.clipboard.writeText(copyText);
          $link.addClass('clicked');
          setTimeout(() => {
            $link.removeClass('clicked');
          }, 2000);
        }
      });
    }

    // resource/event detail related articles
    if ($('.ontinue-related-articles').length > 0) {
      $('.ontinue-related-articles .ontinue-related-articles-inner').slick({
        mobileFirst: true,
        infinite: true,
        dots: true,
        prevArrow: $('.ontinue-related-articles-navigation div:first-child'),
        nextArrow: $('.ontinue-related-articles-navigation div:last-child'),
        appendDots: $('.ontinue-related-articles-navigation div:nth-child(2)'),
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }]
      });
    }

    $('body').on('click', '.footer-scroll-to-top', function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 });
    });

    // data layer
    let dataLayerCounter = 0;
    let datalayerInterval = setInterval(function () {
      // console.log("Checking for gtag");
      if (window.hasOwnProperty('gtag')) {
        // console.log("Found gtag");
        clearInterval(datalayerInterval);
        initDataLayer();
      }
      dataLayerCounter++;
      if (50 === dataLayerCounter)
        clearInterval(datalayerInterval);
    }, 500);

    /* Open Positions page loader */
    const $wrapper = $('.open-positions-loader');
    if ($wrapper.length) {
      const $loader = $('<div class="open-positions-circle-loader"></div>');
      $wrapper.append($loader);
  
      const interval = setInterval(function () {
        const $embed = $wrapper.find('#BambooHR');
        const boardExists = $embed.find('.BambooHR-ATS-board').length > 0;
        const jobsExist = $embed.find('.BambooHR-ATS-Jobs-Item').length > 0;

        //if ($embed.length && $embed.html().trim() !== '') {
        if (boardExists && jobsExist) {
          $loader.remove();
          clearInterval(interval);
        }
      }, 300);
    }


    function initDataLayer() {
      try {
        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        window.gtag('get', 'G-139L0H9P9W', 'client_id', function (client_id) {
          window.rddl.init(client_id, {
            // Optional parameters
            component_class: '',
            form_class: '',
            is_testing: false,
            is_logged_in: false,
            munchkin_id: '',
            segment_id: '',
            user_id: '',
          });


          // Terminus script setup
          function onRambleLoad() {
            Ramble.init({
              code: "10bcd1a441",
              realtimeUrl: "https://chat-team-management.terminus.services",
              fileStoreUrl: "https://di3c8wks3odob.cloudfront.net",
              resolveUTMVariables: true,
              onDataCaptured: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'data_captured',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  dataType: params.type,
                  dataValue: params.value
                });
              },
              onMeetingBooked: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'meeting_booked',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  email: params.email,
                  start_time_stamp: params.startTimestamp,
                  end_time_stamp: params.endTimestamp,
                  description: params.description
                });
              },
              onFirstVisitorInteraction: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'first_interaction',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  message: params.message
                });
              },
              onButtonClick: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'chat_open'
                });
              },
              onChatCompleted: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'Chat Complete',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid
                });
              },
              onChatRequested: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'Chat Requested',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid
                });
              },
              onChatMessage: function (params) {
                window.dataLayer.push({
                  event: 'terminus_chatbot',
                  chat_action: 'Message Sent',
                  visitor_uuid: params.visitorUuid,
                  chat_uuid: params.chatUuid,
                  message: params.message,
                  messageType: params.messageType
                });
              }
            });
          }
          // function lr(e) { console.error("Unable to load ramble snippet: " + e.message); }; var s = document.createElement("script"); s.onerror = lr; s.onload = onRambleLoad; document.head.appendChild(s); s.async = true; s.src = "https://chat-snippet.terminusplatform.com/ramble.snippet.js";

          if ($('.ontinue-contact-grid').length > 0) {
            window.rddl.click('a[href^="tel:"], a[href^="mailto:"]',
              {
                event: 'contactClick',
                linkText: 'link.text',
                linkURL: 'link.url'
              }
            );
          }

          window.rddl.click('.ontinue-sidebar-social a',
            {
              event: 'socialShare',
              socialPlatform: 'link.data.socialPlatform'
            }
          );

          // Store the location (header, body, footer) for each a.button element as a data attribute so that it
          // can be sent with the event
          ['header', 'main', 'footer'].forEach(function (loc) {
            $(loc).find('a.button').each(function () {
              let location = capitalizeFirstLetter('main' === loc ? 'body' : loc);
              $(this).attr('data-location', location);
            });
          });

          // cta click
          window.rddl.click('a.button:not([href^="tel:"]):not([href^="mailto:"])',
            {
              event: 'ctaButton',
              linkText: 'link.text',
              linkURL: 'link.url',
              linkLocation: 'link.data.location', // Location of the CTA button (Header, Body or Footer)
            }
          );

          // marketo form start
          window.rddl.marketo('start', {
            event: 'formStart',
            formID: 'form.marketo_form_id',
            formField: 'form.field_start',
          }, 'click');

          // marketo form submit
          window.rddl.marketo('submit', {
            event: 'formSubmit',
            userID: 'form.fields_filled_hashed.Email', // Hash the email address
            formID: 'form.marketo_form_id', // Marketo Form ID
          }, 'mktoForm');



          // Top nav clicks
          $('#menu-top-menu > li').each(function () {
            let category = $(this).find('> a').text();
            $(this).find('.sub-menu li a').attr('data-category', category);
          });
          window.rddl.click('#menu-top-menu .sub-menu li a', {
            event: 'navigation',
            linkText: 'link.text',
            linkURL: 'link.url',
            linkCategory: 'link.data.category',
          });
        });
      } catch (e) {
        console.error('An error has occurred: ', e);
      }
    }

    // Toggle open class and slide up/down on menu item click
    $('.ontinue-header-wrapper .menu-top-menu-container').on('click', 'ul .ontinue-main-menu', function (e) {
      e.stopPropagation();
      $(this)
        .siblings('.ontinue-main-menu.open')
        .removeClass('open')
        .children('ul')
        .slideUp();
      $(this).toggleClass('open').children('ul').slideToggle();
    });

    // Prevent document click event when clicking on the menu or submenu
    $('.ontinue-header-wrapper .menu-top-menu-container, .ontinue-header-wrapper .menu-top-menu-container .sub-menu-container').on('click', function (e) {
      e.stopPropagation();
    });

    // Remove open class when clicking outside the menu
    $(document).on('click', function () {
      $('.ontinue-main-menu.open')
        .removeClass('open')
        .children('ul')
        .slideUp();
    });

    // Close menu when section ID links are clicked
    $('.sub-menu.depth-1 a').on('click', function () { 
      var href = $(this).attr('href'); 
      if (href.includes('#')) { 
        if ($('body').hasClass('menu-open')) { 
           $('body').removeClass('menu-open'); 
         } 
        if ($('.ontinue-main-menu.open').hasClass('open')) { 
          $('.ontinue-main-menu.open')
            .removeClass('open')
            .children('ul')
            .slideUp();
        }
       } 
    });

  });


});